export default __webpack_public_path__ + "static/media/BusinessManagement360DevPro.63b45240.png";